// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3T67R","upload":"Small_upload__38UkW","imageWrap":"Small_imageWrap__1AT5p","removeBtn":"Small_removeBtn__3c5yx"};